
import { Vue, Component, Prop } from 'nuxt-property-decorator'
import { Salary } from '@/models/job'
import Mixin from '@/mixins'

@Component({
  name: 'JobDescription',
  mixins: [Mixin],
})
export default class JobDescription extends Vue {
  @Prop({ type: String }) readonly title: string
  @Prop({ type: Object }) readonly salary: Salary
  @Prop({ type: String, default: '' }) readonly content: string
  @Prop({ type: String, default: '' }) readonly responsibilities: string
  @Prop({ type: String, default: '' }) readonly requirements: string
}
